import 'animate.css';

const Approach = ({ addMargin = true }) => {
  return (
    <div className={`home3-about-section ${addMargin ? 'sec-mar' : ''}`}>
      <div className='container-fluid'>
        <div className='row g-lg-4 gy-5'>
          {/* Left Section */}
          <div className='col-lg-9'>
            <div
              className='section-title-3 wow animate__animated animate__fadeInUp'
              data-wow-delay='200ms'
              data-wow-duration='1500ms'
            >
              <h2>Our Approach</h2>
              <p>
                We start by diving deep into your brand, your audience, and your
                goals—turning insights into powerful ideas that shape the
                foundation of your digital success. Our team blends strategy,
                creativity, and cutting-edge technology to design solutions that
                don’t just work well, but feel intuitive, modern, and
                unforgettable.With an agile, collaborative mindset, we iterate
                fast, refine continuously, and deliver with precision—ensuring
                your vision transforms into a product that creates real impact.
                Even after launch, we stay by your side, optimizing performance,
                enhancing features, and helping you stay ahead in a constantly
                evolving digital world.
              </p>
            </div>

            <div className='about-left'>
              <div
                className='about-img wow animate__animated animate__fadeInUp'
                data-wow-delay='300ms'
                data-wow-duration='1500ms'
              >
                <img
                  className='img-fluid magnetic-item'
                  src='https://appthing-website.s3.ap-south-1.amazonaws.com/home3-about-1.png'
                  alt=''
                />
              </div>

              <div
                className='about-content wow animate__animated animate__fadeInUp'
                data-wow-delay='400ms'
                data-wow-duration='1500ms'
              >
                <h2>Tailored Solutions for Your Unique Needs</h2>
                <p>
                  We believe in delivering tailored solutions that are designed
                  to address your unique requirements. We take the time to
                  understand your business and provide personalized services
                  that align with your goals.
                </p>
                <div className='devider'></div>

                <ul className='about-feature'>
                  <li>
                    <h5>Customized Solutions</h5>
                    <p>
                      Every product we deliver is unique, scalable, and aligned
                      perfectly with your brand’s long-term vision.
                    </p>
                  </li>
                  <li>
                    <h5>Quality Reliability</h5>
                    <p>
                      Our solutions are built to perform consistently, securely,
                      and reliably—no matter the scale or complexity.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Section */}
          <div className='col-lg-3'>
            <div className='about-right'>
              <div
                className='about-img wow animate__animated animate__fadeInUp'
                data-wow-delay='200ms'
                data-wow-duration='1500ms'
              >
                <img
                  className='img-fluid magnetic-item'
                  src='https://appthing-website.s3.ap-south-1.amazonaws.com/home3-about-2.png'
                  alt=''
                />
              </div>

              <div
                className='about-exprience d-flex align-items-center justify-content-center wow animate__animated animate__fadeInUp'
                data-wow-delay='300ms'
                data-wow-duration='1500ms'
              >
                <div className='exp-text'>
                  <img
                    src='https://appthing-website.s3.ap-south-1.amazonaws.com/rotate-text.png'
                    alt=''
                  />
                </div>
                <div className='years'>
                  <h2>
                    7+
                    <br />
                    <span>Years</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>
          {/* End Right Section */}
        </div>
      </div>
    </div>
  );
};

export default Approach;
